import { IMultiTree, ITree, IUser } from "../types/siembra"


export const normalizeTree = (data: any): ITree => {
    return {
        x: +data.x,
        y: +data.y,
        date: data.date ?? null,
        name: data.name ?? null,
        lastname: data.lastname ?? null
    }
}
export const normalizeMultiTree = (data: any): IMultiTree => {
    const users: any[] = data.users
    return {
        x: +data.x,
        y: +data.y,
        users: users.map(item => normalizeUser(item))
    }
}
export const normalizeUser = (data: any): IUser => {
    return {
        date: data.date,
        name: data.name,
        lastname: data.lastname
    }
}
